import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Cargando from '../../Varios/Cargando';
import { ObtenerInformacionSolicitudes, MapearSolicitudesVacacionesPorAprobar, RechazarSolicitudVacaciones, ValidarSolicitudVacaciones, VistaPreviaSolicitudVacaciones, ValidarPermisoVacaciones } from './FunctionsAprobacionV';
import { SolicitudesVacacionesPorAprobarTH } from './TypesAprobacionesVacaciones';
import TablaAprobacionVacaciones from './TablaAprobacionVacaciones';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { alertService } from 'components/Varios/alert_service';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import Swal from 'sweetalert2';

import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"
import AnuncioSVG from "assets/icons/Permisos/Anuncio.svg"

type StateAprobacionSolicitudes = {
    filasTabla: SolicitudesVacacionesPorAprobarTH[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    mensajeError: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalInformacionValidarVacaciones = {
    url: string,
    cargando: boolean,
    idSolicitud: number,
    tipoSolicitud: string,
    modalContent: HTMLElement | undefined,
    tituloModal: string
}

type StateModalInformacionRechazar = {
    cargando: boolean,
    idSolicitud: number,
    tipoSolicitud: string,
    modalContent: HTMLElement | undefined,
    observacion: string
}

export function showAlertSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        text: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertHTMLSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        html: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertSwalAnuncio(message: string) {
    Swal.fire({
        text: message,
        imageUrl: `${AnuncioSVG}`,
        imageHeight: 100, // Ajusta el tamaño según sea necesario
        imageAlt: "Anuncio",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export default function AprobacionVacaciones() {
    const TITULO_APROBACION_SOLICITUDES = "ELABORACIÓN DE AP DE VACACIONES/REINTEGRO - VALIDACIÓN DE PERMISOS";

    const defaulState: StateAprobacionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        mensajeError: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalInformacionValidarPermisos: StateModalInformacionValidarVacaciones = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        tipoSolicitud: "",
        modalContent: undefined,
        tituloModal: "Solicitud Permiso Vacaciones/Reintegro"
    }

    const defaultStateModalInformacionValidarVacaciones: StateModalInformacionValidarVacaciones = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        tipoSolicitud: "",
        modalContent: undefined,
        tituloModal: "Solicitud Vacaciones/Reintegro"
    }

    const defaultStateModalInformacionRechazar: StateModalInformacionRechazar = {
        cargando: false,
        idSolicitud: -1,
        tipoSolicitud: "",
        modalContent: undefined,
        observacion: ""
    }

    const [stateAprobacion, setstateAprobacion] = useState<StateAprobacionSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [stateinformacionModalAprobarPermisos, setstateinformacionModalAprobarPermisos] = useState(defaultStateModalInformacionValidarPermisos)
    const [stateinformacionModalAprobarVacaciones, setstateinformacionModalAprobarVacaciones] = useState(defaultStateModalInformacionValidarVacaciones)
    const [stateinformacionModalRechazar, setstateinformacionModalRechazar] = useState(defaultStateModalInformacionRechazar)    

    const [observacion, setobservacion] = useState("")

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function ObtenerDatosSolicitudes() {
        setstateAprobacion({ ...stateAprobacion, loadingFilas: true })
        const resultado = await ObtenerInformacionSolicitudes()
        if (resultado.status === 200) {
            if (typeof (resultado.dataResponse) === "string") {
                setstateAprobacion({ ...stateAprobacion, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {
                setstateAprobacion({ ...stateAprobacion, filasTabla: resultado.dataResponse, loadingFilas: false })
            }
        } else {
            setstateAprobacion(prev => ({ ...prev, mensajeError: resultado.errorMessage, loadingFilas: false, errorFilas: true }));
        }
    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //ObtenerDatosSolicitudes();
    }, [])

    async function OnCloseModalRechazo() {
        setstateinformacionModalRechazar(defaultStateModalInformacionRechazar)
        await ObtenerDatosSolicitudes()
        ScrollToTop();
    }

    async function OnCloseModalValidacion() {
        setstateinformacionModalAprobarVacaciones(defaultStateModalInformacionValidarVacaciones)
        setstateinformacionModalAprobarPermisos(defaultStateModalInformacionValidarPermisos)
        await ObtenerDatosSolicitudes()
        ScrollToTop();
    }

    const tablaSolicitudes = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla, mensajeError } = stateAprobacion
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas && mensajeError === undefined) {
            return <div>No ha sido posible cargar la información</div>
        } else if (!loadingFilas && errorFilas && mensajeError) {
            return <div className="alert alert-danger">{mensajeError}</div>;
        }
        else if (filasTabla.length > 0) {
            return (
                <TablaAprobacionVacaciones
                    dataFilas={stateAprobacion.filasTabla}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickRechazar={(solicitud: any) => onClickRechazarSolicitudVacaciones(solicitud)}
                    onClickValidar={(solicitud: any) => onClickAprobarParcialmenteSolicitudVacaciones(solicitud)}
                />
            )
        }
        else {
            return (
                <TablaAprobacionVacaciones
                    dataFilas={[]}
                    onClickVerDocumento={async (referencia: string) => { ; }}
                    onClickRechazar={(solicitud: any) => { ; }}
                    onClickValidar={(solicitud: any) => { ; }}
                />
            )
        }
    }, [stateAprobacion])

    function AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones): any {
        return (
            <>
                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>
                            </td>

                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>
                            </td>

                            <td className="">
                                <div className="">
                                    {informacionAcciones.fechaReintegro
                                        ? ObtenerFechaFromIsoFormat(informacionAcciones.fechaReintegro)
                                        : ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)
                                    }
                                </div>
                            </td>

                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                </div>
                            </td>

                            <td className="">
                                <div className="">
                                    {informacionAcciones.tiempo}
                                </div>
                            </td>

                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>
                            </td>

                        </tr>

                    </tbody>
                </Table>
            </>
        )
    }

    function onClickRechazarSolicitudVacaciones(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones);

        setstateinformacionModalRechazar({
            cargando: false,
            idSolicitud: informacionAcciones.idSolicitudVacacion,
            tipoSolicitud: informacionAcciones.tipoSolicitud,
            modalContent,
            observacion
        })
    }

    async function RechazarVacaciones(idSolicitud, tipoSolicitud, observacion) {
        const respuesta = await RechazarSolicitudVacaciones(idSolicitud, tipoSolicitud, observacion)
        if (respuesta.status !== 200) {
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            OnCloseModalRechazo()
            return 1;
        }
        else {
            if (tipoSolicitud == "Reintegro Vacación") {
                await showAlert("Se ha negado la solicitud de reintegro", ExitoSVG, true);
                OnCloseModalRechazo()
                return -1
            } else {
                await showAlert("Se ha negado la solicitud de vacaciones", ExitoSVG, true);
                OnCloseModalRechazo()
                return -1
            }
        }
    }

    async function onClickAprobarParcialmenteSolicitudVacaciones(informacionAcciones) {
        if (informacionAcciones.tiempo <= 3 && informacionAcciones.tipoSolicitud != "Vacaciones Planificadas") {
            const modalContent = AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones);
            const tituloModal = "Validación Solicitud de " + informacionAcciones.tipoSolicitud
            setstateinformacionModalAprobarPermisos({
                url: "",
                cargando: false,
                tituloModal: tituloModal,
                modalContent: modalContent,
                idSolicitud: informacionAcciones.idSolicitudVacacion,
                tipoSolicitud: informacionAcciones.tipoSolicitud
            })
        }
        else {
            var titulo = "";
            var respuestaSolicitud: ResponseRequest = { status: -1 };
            respuestaSolicitud = await VistaPreviaSolicitudVacaciones(informacionAcciones.idSolicitudVacacion, informacionAcciones.tipoSolicitud);
            if (respuestaSolicitud.status === 200) {
                var content: any = undefined;
                if (informacionAcciones.tipoSolicitud == "Reintegro Vacación") {
                    titulo = "Acción de Personal de Reintegro"
                    setstateinformacionModalAprobarVacaciones({
                        url: respuestaSolicitud.dataResponse,
                        cargando: false,
                        tituloModal: titulo,
                        modalContent: content,
                        idSolicitud: informacionAcciones.idSolicitudVacacion,
                        tipoSolicitud: informacionAcciones.tipoSolicitud
                    })
                } else {
                    titulo = "Acción de Personal de Vacaciones"
                    setstateinformacionModalAprobarVacaciones({
                        url: respuestaSolicitud.dataResponse,
                        cargando: false,
                        tituloModal: titulo,
                        modalContent: content,
                        idSolicitud: informacionAcciones.idSolicitudVacacion,
                        tipoSolicitud: informacionAcciones.tipoSolicitud
                    })
                }
            }
            else {
                alertService.error(respuestaSolicitud.errorMessage ?? "");
            }
        }
    }

    async function OnClickAccionModalFormulario(idSolicitud, tipoSolicitud) {
        setstateinformacionModalAprobarVacaciones({ ...defaultStateModalInformacionValidarVacaciones, cargando: true })
        var accionRealizada = await ValidarSolicitudVacaciones(idSolicitud, tipoSolicitud)
        setstateinformacionModalAprobarVacaciones(defaultStateModalInformacionValidarVacaciones)
        await ObtenerDatosSolicitudes();
    }

    return (
        <div className="content">
            <div className="titulo_seccion mb-5">{TITULO_APROBACION_SOLICITUDES}</div>
            {tablaSolicitudes}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de vacaciones/reintegro'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

            <ModalRechazo
                show={stateinformacionModalRechazar.idSolicitud > 0 || stateinformacionModalRechazar.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazar(defaultStateModalInformacionRechazar)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de " + stateinformacionModalRechazar.tipoSolicitud + "?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarVacaciones(stateinformacionModalRechazar.idSolicitud, stateinformacionModalRechazar.tipoSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazar.modalContent}
                tituloModal={"Negar Solicitud de " + stateinformacionModalRechazar.tipoSolicitud}
                asyncAfterOnClose={() => OnCloseModalRechazo()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            />

            <ModalConfirmacion
                show={stateinformacionModalAprobarPermisos.idSolicitud > 0 || stateinformacionModalAprobarPermisos.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAprobarPermisos(defaultStateModalInformacionValidarPermisos)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea validar la solicitud de " + stateinformacionModalAprobarPermisos.tipoSolicitud + "?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => ValidarPermisoVacaciones(stateinformacionModalAprobarPermisos.idSolicitud, stateinformacionModalAprobarPermisos.tipoSolicitud)}
                contentModal={stateinformacionModalAprobarPermisos.modalContent}
                tituloModal={stateinformacionModalAprobarPermisos.tituloModal}
                asyncAfterOnClose={() => OnCloseModalValidacion()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}

            />

            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalAprobarVacaciones.url !== "" || stateinformacionModalAprobarVacaciones.cargando}
                onClose={() => setstateinformacionModalAprobarVacaciones(defaultStateModalInformacionValidarVacaciones)}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalAprobarVacaciones.cargando}
                size="xl"
                tituloModal={stateinformacionModalAprobarVacaciones.tituloModal}
                urlArchivo={stateinformacionModalAprobarVacaciones.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalAprobarVacaciones.idSolicitud, stateinformacionModalAprobarVacaciones.tipoSolicitud)}
                disabledbuttonCondition={stateinformacionModalAprobarVacaciones.cargando}
                modalContent={stateinformacionModalAprobarVacaciones.modalContent}
            />

        </div>
    )
}